import AppointmentStatusSelect from './AppointmentStatusSelect.view';

export default AppointmentStatusSelect;
